import { render, staticRenderFns } from "./_world-map.vue?vue&type=template&id=278c010e&scoped=true"
import script from "./_world-map.vue?vue&type=script&lang=js"
export * from "./_world-map.vue?vue&type=script&lang=js"
import style0 from "./_world-map.vue?vue&type=style&index=0&id=278c010e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "278c010e",
  null
  
)

export default component.exports